import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import GoogleMapPopup from './GoogleMapPopup';
import useIsMobile from 'hooks/use-is-mobile';
import { SearchPageView } from 'utils/search-page-view';
import { useOnSpot } from './hooks/use-on-spot';
import { useWidget } from './hooks/use-widget';
import { useHandleOnPan } from './hooks/use-handle-on-pan';
import { useMapSideEffects } from './hooks/use-map-side-effects';
/**
 * A component that displays a Google Map with markers for spots.
 */
const SHGoogleMap = ({ destination, spots, zoom, onGoogleMapLoaded, onMarkerClick: onSpotDetailCallback, onPan: onPanProp, onZoom, showAllSpots = false, }) => {
    const isMobile = useIsMobile();
    const { previewedSpotId } = useSelector((state) => state.spots);
    const { view: searchPageView } = useSelector((state) => state.search.data);
    const mapWidgetRef = useRef(null);
    const mapContainerRef = useRef(null);
    const { onSpotDetail } = useOnSpot({
        onSpotDetailCallback, // Look into if this drilling is needed
    });
    const centerLatLng = useMemo(() => ({
        lat: destination.position.latitude,
        lng: destination.position.longitude,
    }), [destination.position.latitude, destination.position.longitude]);
    const handleOnPan = useHandleOnPan({ onPanProp });
    useWidget({
        mapWidgetRef,
        mapContainerRef,
        zoom,
        centerLatLng,
        showAllSpots,
        spots,
        onSpotDetailCallback,
        onZoom,
        onGoogleMapLoaded,
        onPan: handleOnPan,
    });
    useMapSideEffects({ mapWidgetRef, spots });
    return (<>
            {!isMobile && searchPageView === SearchPageView.DESKTOP_LIST && (<GoogleMapPopup spot={previewedSpotId
                ? (spots || []).find(s => s.spotId === previewedSpotId)
                : null} onClick={onSpotDetail} onClose={mapWidgetRef.current?.closePopup}/>)}

            <div ref={mapContainerRef} className="SHGoogleMap"/>
        </>);
};
export default SHGoogleMap;
